/* eslint-disable array-element-newline */
import { Routes } from '@angular/router';

import quizRouteData from '../quiz/components/container/route-data';

import homeRouteData from './components/home/route-data';

export default <Routes>[
  {
    path: '',
    loadComponent: async () => import('./components/page-layout/page-layout.component'),
    children: [
      { path: '', loadComponent: async () => import('./components/home/home.component'), data: homeRouteData },
      { path: 'quiz', loadComponent: async () => import('../quiz/components/container/container.component'), data: quizRouteData }
    ]
  }
];
